import { LoaderService } from './../services/loader.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ebw-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {
  loading: boolean;

  /**
   * in component.scss
   * .loading {
        position: absolute;
        z-index: 2000;
        top: 0;
        left: 0;
        bottom: 0;
      }
  This css class must be inserted in the component where the loader is to be used
  For example in component.ts:  <ebw-loading class="loading"></ebw-loading>
   */

  constructor(private loaderService: LoaderService) {
    this.loaderService.isLoading.subscribe((v) => {
      setTimeout(() => (this.loading = v));
    });
  }

  ngOnInit() {}
}
